import { render, staticRenderFns } from "./DisplayReportBenchmark.vue?vue&type=template&id=8657142c"
import script from "./DisplayReportBenchmark.vue?vue&type=script&lang=ts"
export * from "./DisplayReportBenchmark.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports